"use strict";
import { Deadline } from "uniswap/src/features/transactions/swap/form/header/SwapFormSettings/settingsConfigurations/Deadline/Deadline.web";
export const DeadlineOverride = {
  ...Deadline,
  renderTitle: (t) => t("swap.deadline.settings.title")
};
